// extracted by mini-css-extract-plugin
module.exports = {"cardAction":"styles__cardAction___3zFG9","cardActionLink":"styles__cardActionLink___2urp8"};